<div id="listRender" class="container">
  <div class="numeronlist mx-auto mb-12 w-72 max-w-full rounded-lg bg-white p-4 shadow-lg">
    @if (collectionDisplayImage(collection()); as imagePath) {
      <img [src]="imagePath" alt="" class="block w-full rounded-none" loading="lazy" />
    }

    @if (showCollectionTitle()) {
      <div class="mb-3 mt-4 text-sm text-text">
        <span class="text-primary">
          {{ collection().title }}
        </span>
        <span
          class="ml-1 inline-flex rounded-lg bg-primary px-2 py-1 text-xs font-semibold text-primary-contrast"
        >
          {{ collection().numerons.length }}
        </span>
      </div>
    }

    <small class="lastModified mb-0 mt-2 block text-xs text-secondary">
      Last Modified:
      {{ collection().lastModified | date: 'dd-MMM-yyyy h:mm a' }}
    </small>

    @if (hasNumerons(collection())) {
      <ul class="m-0 list-none p-0">
        @for (numeron of collection().numerons; track numeron._id) {
          <li class="overflow-auto pt-2.5">
            @if (isImageNumeron(numeron)) {
              @if (numeron.assetPath) {
                <img
                  [src]="numeron.assetPath"
                  [alt]="numeron.title"
                  class="float-left mr-4 w-20 rounded-none"
                  loading="lazy"
                />
              }
              <h5 class="m-0 text-lg">{{ numeron.numeral }}</h5>
            } @else {
              <div
                class="panel float-left mr-4 w-24 rounded-none text-center"
                [ngClass]="panelSubtypeClasses(numeron.subType)"
              >
                <span class="numeral m-0 text-base">{{ numeron.numeral }}</span>
              </div>
            }

            @if (listItemHasLinkedTitle(numeron)) {
              <div class="title text-sm leading-5 text-text">
                <a
                  [href]="numeron.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-secondary no-underline"
                >
                  {{ numeron.title }}
                </a>
              </div>
            } @else {
              <div class="title text-sm leading-5 text-text">{{ numeron.title }}</div>
            }

            @if (showManagementActions()) {
              <div class="mt-2 flex justify-end gap-2">
                <a
                  class="inline-flex items-center rounded-md bg-sky-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-200 ease-in-out hover:bg-sky-700"
                  [routerLink]="updateNumeronHref(collection()._id, numeron._id)"
                  aria-label="Update numeron"
                  title="Update Numeron"
                >
                  Update
                </a>
                <a
                  class="inline-flex items-center rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-200 ease-in-out hover:bg-red-700"
                  [routerLink]="deleteNumeronHref(collection()._id, numeron._id)"
                  aria-label="Delete numeron"
                  title="Delete Numeron"
                >
                  Delete
                </a>
              </div>
            }
          </li>
        }
      </ul>
    } @else if (showManagementActions()) {
      <p class="mt-4 text-sm text-text-muted">
        This collection is empty. Use Add Numeron to start building it.
      </p>
    }

    <div class="usage my-2.5">
      <div class="row m-0 flex">
        <div class="col-xs-3 w-1/4">
          <div class="likes">
            <span class="inline-flex rounded p-0.5 text-text" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                class="h-4 w-4"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            </span>
            @if ((collection().views ?? 0) > 0) {
              <small class="m-0 text-sm text-text">{{ collection().views }}</small>
            }
          </div>
        </div>

        <div class="col-xs-3 w-1/4">
          <div class="likes">
            <button
              type="button"
              class="inline-flex rounded p-0.5 text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
              (click)="likeCollection()"
              aria-label="Like collection"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                class="h-4 w-4"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21.435 6.582-1.89-1.89a5.25 5.25 0 0 0-7.424 0L12 4.813l-.121-.121a5.25 5.25 0 0 0-7.425 7.424l1.89 1.89L12 19.667l5.656-5.66 1.89-1.89a5.25 5.25 0 0 0-.111-7.535Z"
                />
              </svg>
            </button>
            @if (collectionLikes() > 0) {
              <small class="m-0 text-sm text-text">{{ collectionLikes() }}</small>
            }
          </div>
        </div>

        <div class="col-xs-3 w-1/4">
          <div class="likes">
            <a title="Convert to Image" class="inline-flex text-text">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                class="h-4 w-4"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m2.25 15.75 5.16-5.16a2.25 2.25 0 0 1 3.182 0l5.16 5.16m-1.5-1.5 1.41-1.41a2.25 2.25 0 0 1 3.182 0l3.16 3.16m-18.75-9.75h16.5a2.25 2.25 0 0 1 2.25 2.25v11.25A2.25 2.25 0 0 1 19.5 21.75H4.5a2.25 2.25 0 0 1-2.25-2.25V8.25A2.25 2.25 0 0 1 4.5 6h16.5M15 10.5h.008v.008H15V10.5Z"
                />
              </svg>
            </a>
          </div>
        </div>

        <div class="col-xs-3 w-1/4">
          <div class="likes">
            @if (hasCollectionEmail(collection())) {
              <a
                [href]="collectionEmailHref(collection())"
                title="Email Author"
                class="inline-flex text-text"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  class="h-4 w-4"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.914A2.25 2.25 0 0 1 2.25 6.998V6.75"
                  />
                </svg>
              </a>
            } @else {
              <a title="Email Author" class="inline-flex text-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  class="h-4 w-4 opacity-60"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.914A2.25 2.25 0 0 1 2.25 6.998V6.75"
                  />
                </svg>
              </a>
            }
          </div>
        </div>
      </div>
    </div>

    <hr class="m-0 border-0 border-t border-subtle" />

    @if ((collection().actions?.length ?? 0) > 0) {
      <div class="interactions my-4">
        <ul class="m-0 w-full list-none p-0">
          @for (action of collection().actions ?? []; track action._id ?? action.name ?? $index) {
            <li class="overflow-auto px-2.5 pt-1.5">
              @if (action.identifier === 'CallNow' && action.url) {
                <a [href]="'tel:' + action.url" class="text-text no-underline">Call Now</a>
              } @else if (action.identifier === 'SendMessage' && action.url) {
                <a [href]="'mailto:' + action.url" class="text-text no-underline">Send Message</a>
              } @else if (action.actionInternal === false && action.url) {
                <a
                  [href]="action.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-text no-underline"
                >
                  {{ action.name }}
                </a>
              }
            </li>
          }
        </ul>
      </div>

      <hr class="m-0 border-0 border-t border-subtle" />
    }

    <div class="metadata my-2.5">
      <div class="text-sm text-text-muted">
        Posted by
        @if (showManagementActions()) {
          <span class="font-semibold text-text">{{ collection().user?.displayName }}</span>
        } @else {
          <a [href]="byPublisherHref(collection().user?._id)" class="text-secondary no-underline">
            {{ collection().user?.displayName }}
          </a>
        }
        in
        @if (showManagementActions()) {
          <span class="font-semibold text-text">{{ collection().topic?.topic }}</span>
        } @else {
          <a [href]="byTopicHref(collection().topic?._id)" class="text-secondary no-underline">
            {{ collection().topic?.topic }}
          </a>
        }
      </div>

      <div class="text-sm text-text-muted">
        Tags
        @for (category of collection().categories ?? []; track category) {
          @if (showManagementActions()) {
            <span class="font-semibold text-text"
              >{{ category }}@if (!$last) {<span>, </span>}</span
            >
          } @else {
            <a [href]="byCategoryHref(category)" class="text-secondary no-underline">
              {{ category }}
            </a>
          }
        }
      </div>

      <div class="source mt-2.5 text-sm text-text-muted">
        Source
        @if (hasExternalSource(collection().url)) {
          <a
            [href]="collection().url"
            target="_blank"
            rel="noopener noreferrer"
            class="text-secondary no-underline"
          >
            {{ collection().source }}
          </a>
        } @else {
          {{ collection().source }}
        }
      </div>
    </div>

    <hr class="m-0 border-0 border-t border-subtle" />

    @if (showManagementActions()) {
      <div class="mt-3 grid grid-cols-4">
        <a
          class="inline-flex items-center justify-center text-text-muted"
          [routerLink]="addNumeronHref(collection()._id)"
          aria-label="Add numeron"
          title="Add Numeron"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-4 w-4"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </a>
        <a
          class="inline-flex items-center justify-center text-text-muted"
          [routerLink]="editCollectionHref(collection())"
          [queryParams]="editCollectionQueryParams(collection())"
          aria-label="Edit collection"
          title="Edit Collection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-4 w-4"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a2.25 2.25 0 1 1 3.182 3.182L10.582 17.13a4.5 4.5 0 0 1-1.897 1.13L6 19l.74-2.685a4.5 4.5 0 0 1 1.13-1.897L16.862 4.487Z"
            />
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 7.125 16.875 4.5" />
          </svg>
        </a>
        <button
          type="button"
          class="inline-flex items-center justify-center text-text-muted"
          [disabled]="isCopying()"
          (click)="copyCollection()"
          aria-label="Copy collection"
          title="Copy Collection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-4 w-4"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125H6.375a1.125 1.125 0 0 1-1.125-1.125V8.25c0-.621.504-1.125 1.125-1.125H9.75"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 3.75h4.125c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125H10.875A1.125 1.125 0 0 1 9.75 16.125V4.875c0-.621.504-1.125 1.125-1.125H15Z"
            />
          </svg>
        </button>
        <a
          class="inline-flex items-center justify-center text-text-muted"
          [routerLink]="deleteCollectionHref(collection())"
          [queryParams]="deleteCollectionQueryParams(collection())"
          aria-label="Delete collection"
          title="Delete Collection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-4 w-4"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673A2.25 2.25 0 0 1 15.916 21.75H8.084A2.25 2.25 0 0 1 5.84 19.673L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0C9.165 2.313 8.255 3.296 8.255 4.477v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
            />
          </svg>
        </a>
      </div>

      @if (copyErrorMessage()) {
        <p class="mt-3 text-sm text-danger">{{ copyErrorMessage() }}</p>
      }

      <hr class="mb-0 mt-3 border-0 border-t border-subtle" />
    }

    <div class="social-share mx-5 mb-2.5 mt-5"></div>
  </div>
</div>
